module.exports = __webpack_public_path__ + "static/logo-74f6d3bc9c79748e05370a0528c7414f.svg";